import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  FileText,
  Search,
  DollarSign,
  Building2,
  CreditCard,
  Users,
  Package,
  TrendingUp,
  TrendingDown,
  Briefcase,
  Home,
  TicketCheck,
  Landmark,
  HandCoins,
} from "lucide-react";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import { FaSave, FaEye, FaPlus } from "react-icons/fa";
import {
  TbLayoutSidebarRightExpand,
  TbLayoutSidebarLeftExpand,
} from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../components/common/CommonModal";
import CreditCustomerList from "../components/common/CreditCustomerList";

const Payment = () => {
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment") || "-";
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [selectedRows, setSelectedRows] = useState([]);
  const [isFilterByDate, setIsFilterByDate] = useState(false);
  const [isOnAc, setIsOnAc] = useState(false);
  const [debitModalOpen, setDebitModalOpen] = useState(false);
  const [differenceModalOpen, setDifferenceModalOpen] = useState(false);
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [isExtendTable, setIsExtendTable] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState(null);
  const [filteredCreditAccounts, setFilteredCreditAccounts] = useState(null);
  const [selectedDebitAccount, setselectedDebitAccount] = useState(null);
  const [selectedDifferenceAccount, setselectedDifferenceAccount] =
    useState(null);
  const [selectedCreditAccount, setselectedCreditAccount] = useState(null);
  const [inputDebitValue, setinputDebitValue] = useState("-");
  const [inputDebitValueAccount, setinputDebitValueAccount] = useState("");
  const [inputDebitValueDescription, setinputDebitValueDescription] =
    useState("");
  const [inputDifferenceValue, setinputDifferenceValue] = useState("");
  const [inputDifferenceValueAccount, setinputDifferenceValueAccount] =
    useState("");
  const [inputDifferenceValueDescription, setinputDifferenceValueDescription] =
    useState("");
  const [inputCreditValue, setinputCreditValue] = useState("-");
  const [inputCreditValueAccount, setinputCreditValueAccount] = useState("");
  const [inputCreditValueDescription, setinputCreditValueDescription] =
    useState("");
  const [searchCreditAccountTerm, setSearchCreditAccountTerm] = useState(null);
  const [searchDebitAccountTerm, setSearchDebitAccountTerm] = useState(null);
  const [searchDifferenceAccountTerm, setSearchDifferenceAccountTerm] =
    useState(null);
  const [accounts, setAccounts] = useState(null);
  const [outstandingPV, setOutstandingPV] = useState(null);
  const [outstandingSearchTerm, setOutstandingSearchTerm] = useState("");
  const [creditAccounts, setCreditAccounts] = useState(null);
  const [initialDrList, setInitialDrList] = useState(null);
  const [pvnoFromAPI, setPVnoFromAPI] = useState(null);
  const [value, setValue] = useState("ALL");
  const [valueToDebit, setValueToDebit] = useState("SUPPLIERS");
  const [valueToDifference, setValueToDifference] = useState("EXPENSES");
  const [pvType, setPvType] = useState("PV-C");
  const [pvApiUrl, setPVApiUrl] = useState("");
  const [selectedCr, setselectedCr] = useState("");
  const [selectedCrDesc, setselectedCrDesc] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const [creditDropdownOpen, setCreditDropdownOpen] = useState(false);
  const [debitDropdownOpen, setDebitDropdownOpen] = useState(false);
  const [differenceDropdownOpen, setDifferenceDropdownOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [amounts, setAmounts] = useState([]);
  const [sumOfAmounts, setSumOfAmounts] = useState(null);
  const [drWrapperFocus, setDrWrapperFocus] = useState(false);
  const drInputWrapperRef = useRef(null);
  const drInputRef = useRef(null);
  const searchInputRef = useRef(null);
  const onACdebitRef = useRef(null);
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [fcType, setFcType] = useState("");
  const [amtPaid, setAmtPaid] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [paymentSavedPopup, setPaymentSavedPopup] = useState(false);
  const [jvDate, setJvDate] = useState(new Date().toISOString().split("T")[0]);
  const [descriptionInput, setDescriptionInput] = useState("");
  const [vNO, setVNO] = useState(null);
  const [commentsInput, setCommentsInput] = useState("");
  const [jobCodeInput, setJobCodeInput] = useState("");
  const [cCenterInput, setcCenterInput] = useState("");
  const [salesmanList, setSalesmanList] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState(null);
  const [creditCardNo, setCreditCardNo] = useState(null);
  const [chequeNO, setChequeNO] = useState(null);
  // const [chequeDate, setChequeDate] = useState(
  //   new Date().toISOString().split("T")[0]
  // );
  const [chequeDate, setChequeDate] = useState(null);
  const [chequeBank, setChequeBank] = useState(null);
  const [transferAccountBlock, setTransferAccountBlock] = useState(false);
  const [transferAccountPopup, setTransferAccountPopup] = useState(false);
  const [differenceAmount, setDifferenceAmount] = useState(null);
  const currentDate = dayjs().format("YYYY-MM-DD");
  const [isEditMode, setIsEditMode] = useState(false);

  const location = useLocation();
  const mapPVType = (value) => {
    switch (value) {
      case "bank":
      case "creditcard":
      case "PV-B":
        return "PV-B";

      case "cheque":
      case "PV-Q":
        return "PV-Q";

      case "cash":
      case "PV-C":
        return "PV-C";

      default:
        return "";
    }
  };
  const mapJVTypeToPayment = (jvType) => {
    switch (jvType) {
      case "PV-C":
        return "cash";
      case "PV-B":
        return "bank"; // OR creditcard (see note below)
      case "PV-Q":
        return "cheque";
      default:
        return "cash";
    }
  };

  useEffect(() => {
    const editPaymentData = location?.state?.pvEditData;
    if (!editPaymentData) return;

    console.log("editPaymentData:", editPaymentData);

    setIsEditMode(true);
    setinputDebitValue(
      `${editPaymentData.ACCOUNT} | ${editPaymentData.CUSTOMER}`,
    );
    setselectedDebitAccount(editPaymentData);
    setinputDebitValueAccount(editPaymentData.ACCOUNT);
    setinputDebitValueDescription(editPaymentData.CUSTOMER);

    // ✅ Set PV Type (existing flow)
    setPvType(editPaymentData.JVTYPE);

    // ✅ Set selected radio
    const paymentMode = mapJVTypeToPayment(editPaymentData.JVTYPE);
    setSelected(paymentMode);
  }, [location?.state?.pvEditData]);

  // Reset form function
  const resetForm = () => {
    setSelectedRows([]);
    setIsFilterByDate(false);
    setIsOnAc(false);
    setDebitModalOpen(false);
    setDifferenceModalOpen(false);
    setCreditModalOpen(false);
    setIsExtendTable(false);
    setselectedDebitAccount(null);
    setselectedDifferenceAccount(null);
    // setselectedCreditAccount(null);
    // setselectedCr("");
    // setselectedCrDesc("");
    setinputDebitValue("-");
    setinputDebitValueAccount("");
    setinputDebitValueDescription("");
    setinputDifferenceValue("");
    setinputDifferenceValueAccount("");
    setinputDifferenceValueDescription("");
    // setinputCreditValue("-");
    // setinputCreditValueAccount("");
    // setinputCreditValueDescription("");
    setSearchCreditAccountTerm(null);
    setSearchDebitAccountTerm(null);
    setSearchDifferenceAccountTerm(null);
    setOutstandingPV(null);
    setValue("ALL");
    setValueToDebit("SUPPLIERS");
    setValueToDifference("EXPENSES");
    setPvType("PV-C");
    setCreditDropdownOpen(false);
    setDebitDropdownOpen(false);
    setDifferenceDropdownOpen(false);
    setPaymentMethod("cash");
    setAmounts([]);
    setSumOfAmounts(null);
    setDrWrapperFocus(true);
    setFromDate(today);
    setToDate(today);
    // setFromDate(null);
    // setToDate(null);
    setSelectedToggle([]);
    setFcType(currencies[0]?.curno || "");
    setAmtPaid("");
    setIsTableVisible(false);
    setSelectedCurrency(currencies[0] || null); // Reset to default currency
    setJvDate(today);
    setDescriptionInput("");
    setVNO(null);
    setCommentsInput("");
    setJobCodeInput("");
    setcCenterInput("");
    setSelectedSalesman(null);
    setCreditCardNo(null);
    setChequeNO(null);
    setChequeDate(null);
    setChequeBank(null);
    setTransferAccountBlock(false);
    setTransferAccountPopup(false);
    setDifferenceAmount(null);

    // Re-fetch PV number to get the next voucher number
    fetchPVList();

    // Set focus back to Debit input
    setTimeout(() => {
      if (drInputRef.current) {
        drInputRef.current.focus();
      }
    }, 0);
  };

  const handleClear = () => {
    setFromDate(today);
    setToDate(today);
  };

  useEffect(() => {
    if (creditModalOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [creditModalOpen]);

  useEffect(() => {
    const rate = (selectedCurrency || currencies[0])?.rate ?? 1;
    setDifferenceAmount((amtPaid * rate) - sumOfAmounts);
  }, [amtPaid, sumOfAmounts, selectedCurrency, currencies]);

  useEffect(() => {
    if (valueToDebit) {
      fetchAccountList(valueToDebit);
    }
  }, [valueToDebit]);

  useEffect(() => {
    if (valueToDifference) {
      fetchAccountList(valueToDifference);
    }
  }, [valueToDifference]);

  useEffect(() => {
    fetchCurrencyList();
    fetchAccountList();
    fetchAccountCreditList("ALL");
    fetchPVList();
    fetchInitialDrList();
    fetchSalesmanList();
    fetchSalesmanFromLocal();
    setTimeout(() => {
      if (drInputRef.current) {
        drInputRef.current.focus();
      }
      setDrWrapperFocus(true);
    }, 0);
  }, []);

  useEffect(() => {
    if (inputDebitValue?.length > 1) {
      setIsTableVisible(true);
      fetchOutstandingPV(selectedDebitAccount?.ACCOUNT); // ← ADD THIS
      setDrWrapperFocus(false);
    } else {
      setIsTableVisible(false);
      if (drInputRef.current) {
        drInputRef.current.focus();
      }
      setDrWrapperFocus(true);
    }
  }, [inputDebitValue]);
  // useEffect(() => {
  //   if (isTableVisible) {
  //     fetchOutstandingPV(selectedDebitAccount?.ACCOUNT);
  //     console.log("selectedDebitAccount?.ACCOUNT Running!",selectedDebitAccount?.ACCOUNT)
  //   }
  // }, [isTableVisible]);

  useEffect(() => {
    if (isOnAc && onACdebitRef.current) {
      onACdebitRef.current.focus();
    }
  }, [isOnAc]);

  let company_code_from_local_storage =
    localStorage.getItem("companyCode") || "-";
  let currentSelectedDepartment =
    localStorage.getItem("currentSelectedDepartment") || "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  useEffect(() => {
    setFilteredAccounts(accounts);
  }, [accounts]);

  // useEffect(() => {
  //   setFilteredCreditAccounts(creditAccounts);
  // }, [creditAccounts]);

  useEffect(() => {
    if (!inputDebitValue?.trim()) {
      setFilteredCreditAccounts(creditAccounts);
    } else {
      const term = inputDebitValue?.toLowerCase();
      const filtered = creditAccounts?.filter(
        (acc) =>
          acc.ACCOUNT?.toLowerCase()?.includes(term) ||
          acc.DESCRIPTION?.toLowerCase()?.includes(term),
      );
      setFilteredCreditAccounts(filtered);
    }
  }, [inputDebitValue, creditAccounts]);

  useEffect(() => {
    let valueToAPI = "";
    if (paymentMethod === "cash") {
      valueToAPI = "cash";
    } else if (paymentMethod === "cheque") {
      valueToAPI = "pdc";
    } else if (paymentMethod === "bank") {
      valueToAPI = "bank";
    } else if (paymentMethod === "creditcard") {
      valueToAPI = "bank";
    }

    if (valueToAPI) {
      fetchAccountList(valueToAPI);
      const allowedType = typeMapping[paymentMethod?.toLowerCase()] || null;
      if (allowedType) {
        setValue(allowedType.toUpperCase());
      }
    }
  }, [paymentMethod]);

  // Ensure selectedCurrency is initialized once currencies are loaded
  useEffect(() => {
    if (currencies.length > 0 && !selectedCurrency) {
      const defaultCurrency =
        currencies.find((item) => item.rate === 1) || currencies[0];
      setSelectedCurrency(defaultCurrency);
    }
  }, [currencies, selectedCurrency]);

  const debitSearchInputRef = useRef(null);
  const creditSearchInputRef = useRef(null);
  const differenceSearchInputRef = useRef(null);

  useEffect(() => {
    if (debitModalOpen && debitSearchInputRef.current) {
      debitSearchInputRef.current.focus();
    }
  }, [debitModalOpen]);
  useEffect(() => {
    if (creditModalOpen && creditSearchInputRef.current) {
      creditSearchInputRef.current.focus();
    }
  }, [creditModalOpen]);
  useEffect(() => {
    if (differenceModalOpen && differenceSearchInputRef.current) {
      differenceSearchInputRef.current.focus();
    }
  }, [differenceModalOpen]);

  const fetchSalesmanFromLocal = () => {
    let currentUser_from_local_storage =
      localStorage.getItem("currentUser") || "-";
    const salesman_from_local_storage =
      JSON.parse(currentUser_from_local_storage)?.[0]?.sales_man || "-";
    setSelectedSalesman(salesman_from_local_storage);
  };

  const fetchSalesmanList = async () => {
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentSelectedDepartment}`;
    try {
      const response = await axios.get(url);
      setSalesmanList(response.data || []);
    } catch (err) {
      console.error("Error while loading salesman List data:", err);
      setSalesmanList([]);
    }
  };

  const fetchOutstandingPV = async (accountNumber) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstandingRVPV/${COMPANY_CODE}/PAYMENTS/${fromDate}/${toDate}/${accountNumber}/-/-/-`;
    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstandingRVPV/${COMPANY_CODE}/PAYMENTS/${fromDate}/${toDate}/${selectedDebitAccount?.ACCOUNT}/-/-/-`;
    try {
      const response = await axios.get(apiUrl);
      setOutstandingPV(response.data);
      console.log("Outstanding response for print", response.data);
    } catch (err) {
      console.error("Error while fetchOutstandingPV", err);
    }
  };

  const fetchAccountList = async (valueToAPI) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG
      }/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${currentSelectedDepartment}/${valueToAPI || "SUPPLIERS"
      }/-/-`;
    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data);
    } catch (err) {
      console.error("Error while fetching account list", err);
    }
  };

  const fetchAccountCreditList = async (valueToAPI) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${currentSelectedDepartment}/${valueToAPI}/-/-`;
    try {
      const response = await axios.get(apiUrl);
      setCreditAccounts(response.data);
    } catch (err) {
      console.error("Error while fetching credit account list", err);
    }
  };

  useEffect(() => {
    fetchPVList();
    fetchInitialDrList();
  }, [pvType]);

  const fetchPVList = async () => {
    const apiUrlPV = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/${pvType}/-`;
    try {
      const response = await axios.get(apiUrlPV);
      const pvNumberFromAPI = response.data[0].NEXT_NO;
      if (pvNumberFromAPI > 0) {
        setPVnoFromAPI(pvNumberFromAPI);
      } else {
        let apiUrl2 = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/PV/-`;
        try {
          const response = await axios.get(apiUrl2);
          setPVnoFromAPI(response.data[0].NEXT_NO);
          setPvType("PV");
        } catch (err) {
          console.error("Error while fetching PV List", err);
        }
      }
    } catch (err) {
      console.error("Error while fetching PV List", err);
    }
  };

  const fetchInitialDrList = async () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/Scrn_code/PV/-/${currentSelectedDepartment}/-`;
    try {
      const response = await axios.get(apiUrl);
      setInitialDrList(response.data);
      setAccountByPaymentMethod(paymentMethod, response.data);
    } catch (err) {
      console.error("Error while fetching initial Dr list", err);
    }
  };

  const setAccountByPaymentMethod = (paymentMethod, data) => {
    let scrnCode = "";
    switch (paymentMethod.toLowerCase()) {
      case "cash":
        scrnCode = "PV-CA-C";
        break;
      case "bank":
        scrnCode = "PV-BA-C";
        break;
      case "cheque":
        scrnCode = "PV-CQ-C";
        break;
      case "creditcard":
        scrnCode = "PV-BA-C";
        break;
      default:
        return;
    }
    const account = data.find((item) => item.Scrn_code === scrnCode);
    if (account && account.ACCOUNT) {
      setselectedCr(account.ACCOUNT);
      setselectedCrDesc(account.accdesc);
    }
  };

  const toggleRow = (voucherNo) => {
    setSelectedRows((prev) =>
      prev.includes(voucherNo)
        ? prev.filter((id) => id !== voucherNo)
        : [...prev, voucherNo],
    );
  };

  const handleChangePayment = (e) => {
    setPaymentMethod(e.target.value);
  };

  const clearDebitAccounts = () => {
    setinputDebitValue("-");
    setselectedDebitAccount(null);
    setinputDebitValueAccount("");
    setinputDebitValueDescription("");
  };

  const clearDifferenceAccounts = () => {
    setinputDifferenceValue("");
    setselectedDifferenceAccount(null);
    setinputDifferenceValueAccount("");
    setinputDifferenceValueDescription("");
  };

  const clearCreditAccounts = () => {
    setinputCreditValue("-");
    setselectedCreditAccount(null);
    setinputCreditValueAccount("");
    setinputCreditValueDescription("");
  };

  const handleChangePVType = (e) => {
    const newValue = e.target.value;
    setPvType(mapPVType(newValue));
  };

  const formatBalance = (balance) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  useEffect(() => {
    if (selectedCr || selectedCrDesc) {
      setinputCreditValue(`${selectedCr || ""} | ${selectedCrDesc || ""}`);
    } else if (selectedCreditAccount) {
      setinputCreditValue(
        `${selectedCreditAccount.ACCOUNT} | ${selectedCreditAccount.DESCRIPTION || ""
        }`,
      );
    } else {
      setinputCreditValue("-");
    }
  }, [selectedCreditAccount, selectedCr, selectedCrDesc]);

  const types = [
    { name: "All", icon: Home },
    { name: "Cash", icon: DollarSign },
    { name: "Bank", icon: Landmark },
    { name: "PDC", icon: TicketCheck },
    { name: "Customers", icon: Users },
    { name: "Suppliers", icon: Package },
    { name: "Assets", icon: Briefcase },
    { name: "Liabilities", icon: CreditCard },
    { name: "Income", icon: TrendingUp },
    { name: "Expenses", icon: TrendingDown },
    { name: "InExpenses", icon: HandCoins },
    { name: "InterCompany", icon: Building2, disable: false },
  ];

  const typeMapping = {
    cash: "Cash",
    cheque: "PDC",
    bank: "Bank",
    creditcard: "Bank",
  };

  const dropdowndebitRef = useRef(null);
  const dropdowncreditRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdowndebitRef.current &&
        !dropdowndebitRef.current.contains(event.target)
      ) {
        setCreditDropdownOpen(false);
      }
      if (
        dropdowncreditRef.current &&
        !dropdowncreditRef.current.contains(event.target)
      ) {
        setDebitDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [selected, setSelected] = useState("cash");

  const handleChange = (e) => {
    setValue(e.target.value);
    setSelected(e.target.value);
    handleChangePayment(e);
    handleChangePVType(e);
  };

  const handleAmountChange = (index, value) => {
    const updated = [...amounts];
    updated[index] = Number(value) || 0;
    setAmounts(updated);
  };

  const handleSelectToggle = (index, checked, balAmt) => {
    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      return updated;
    });
    setAmounts((prev) => {
      const updated = [...prev];
      updated[index] = checked ? balAmt : "";
      return updated;
    });
  };

  useEffect(() => {
    const totalAmount = amounts?.reduce((acc, val) => acc + Number(val), 0);
    setSumOfAmounts(totalAmount);
  }, [amounts]);

  useEffect(() => {
    if (Array.isArray(outstandingPV)) {
      setAmounts(outstandingPV.map((row) => row?.AMOUNT || ""));
    }
  }, [outstandingPV]);

  const onSavePayment = () => {
    if (!commentsInput || commentsInput.trim() === "") {
      alert("Please enter comments before saving.");
      return;
    }

    if (isChequeInvalid) {
      alert("Please fill Cheque No, Date and Bank");
      return;
    }

    // If user chose "On A/C", treat this as an immediate save
    if (isOnAc) {
      paymentSaveAPI();
      return;
    }

    // 1. If balanced, save immediately
    if (Math.abs(Number(differenceAmount || 0)) < 0.001) {
      paymentSaveAPI();
    }
    // 2. If there's a difference and user already confirmed the transfer account
    else if (transferAccountBlock && inputDifferenceValue.length > 0) {
      paymentSaveAPI();
    }
    // 3. If there's a difference but user hasn't confirmed where to put it yet
    else {
      setTransferAccountPopup(true);
      // REMOVED: navigate("/paymentView");
      // Stay on the page so the user can see the popup and pick an account
    }
  };

  const onConfirmPaymentTransferPopup = () => {
    setTransferAccountBlock(true);
    setTransferAccountPopup(false);

    // Optional: Automatically trigger save after confirmation
    // paymentSaveAPI();
  };

  const paymentSaveAPI = async () => {
    let company_code_from_local_storage =
      localStorage.getItem("companyCode") || "-";
    let currentSelectedDepartment_from_local_storage =
      localStorage.getItem("currentSelectedDepartment") || "-";
    let currentUser_from_local_storage =
      localStorage.getItem("currentUser") || "-";
    const user_from_local_storage =
      JSON.parse(currentUser_from_local_storage)?.[0]?.user || "";

    const buildReceiptPayload = () => {
      const commonFields = {
        cmpcode: company_code_from_local_storage,
        operation: isEditMode ? "EDIT" : "ENTRY",
        JVTYPE: pvType || "",
        TYPE_NO: pvnoFromAPI || "",
        JVDATE: jvDate || "",
        CUST_ACC: inputDebitValueAccount || "",
        ACCDESC: "",
        AMOUNT: "0",
        DESCRIPT: descriptionInput || "",
        DEPTNO: DEPARTMENT || "",
        COMMENTS: commentsInput || "",
        USERID: selectedCr || inputCreditValueAccount || "",
        job_code: jobCodeInput || "",
        sman_code: selectedSalesman?.EMP_ID || "",
        costc: cCenterInput || "",
        chqno: chequeNO || "",
        chqdate: chequeDate || null,
        rate: (selectedCurrency || currencies[0])?.rate?.toFixed(6) || "",
        pdcstatus: "",
        pdc_acc: "",
        reason: commentsInput || "",
        account: "",
        jvnum: pvnoFromAPI || "",
        ref: "",
        entry_ref: commentsInput || "",
        type: "",
        curno: (selectedCurrency || currencies[0])?.curno || "",
        curamount: Number(amtPaid).toFixed(2) || "",
        user_id: user_from_local_storage?.trim() || "",
        accountype: "",
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: chequeBank || "",
        due_date: currentDate || "",
        doc_date: currentDate || "",
        month: "0",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: cCenterInput || "",
        ttref: "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: "0",
        COSTCODE: cCenterInput || "",
      };

      const bcAmount =
        amtPaid * ((selectedCurrency || currencies[0])?.rate ?? 1);
      const defaultCurrency =
        currencies.find((c) => c.rate === 1) || currencies[0];
      const creditEntry = {
        ...commonFields,
        ACCDESC: inputDebitValueDescription || "",
        AMOUNT: Number(bcAmount).toFixed(2) || "",
        curamount: Number(amtPaid).toFixed(2) || "",
        pdc_acc: inputDebitValueAccount || "",
        account: selectedCr || inputCreditValueAccount || "",
        ref: pvnoFromAPI + "" || "",
        type: "C",
        curno: (selectedCurrency || currencies[0])?.curno || "",
        accountype: "1",
      };

      // If "On A/C" is selected, create a matching debit entry for the full amount
      if (isOnAc) {
        const debitOnAc = {
          ...commonFields,
          ACCDESC: inputDebitValueDescription || "",
          AMOUNT: Number(bcAmount).toFixed(2) || "",
          curamount: Number(amtPaid).toFixed(2) || "",
          pdc_acc: selectedCr || inputCreditValueAccount || "",
          account: inputDebitValueAccount || "",
          ref: "ON A/C",
          type: "D",
          rate: (selectedCurrency || currencies[0])?.rate?.toFixed(6) || "",
          curno: (selectedCurrency || currencies[0])?.curno || "",
          accountype: "2",
        };

        // ensure credit entry also carries ON A/C ref so API sees the pair
        const creditWithOnAcRef = { ...creditEntry, ref: "ON A/C" };

        return [creditWithOnAcRef, debitOnAc];
      }

      const debitEntries = outstandingPV
        ?.map((outPV, index) => {
          const amount = Number(amounts[index]);
          if (!amount || amount === 0) return null;
          const billRate =
            currencies.find((c) => c.curno === outPV?.CUR)?.rate || 1;
          return {
            ...commonFields,
            ACCDESC: outPV?.DESCR || "",
            AMOUNT: Number(amount).toFixed(2),
            curamount: (amount / billRate).toFixed(2) || "",
            pdc_acc: selectedCr || inputCreditValueAccount || "",
            account: inputDebitValueAccount || "",
            ref: outPV?.INV + "" || "",
            type: "D",
            rate: billRate.toFixed(6) || "",
            curno: outPV?.CUR || "",
            accountype: "2",
          };
        })
        .filter(Boolean);

      let differenceEntry = null;
      if (transferAccountBlock && inputDifferenceValue.length > 0) {
        const diffType = differenceAmount < 0 ? "D" : "C";
        const bcDiffAmount =
          Math.abs(differenceAmount) *
          ((selectedCurrency || currencies[0])?.rate ?? 1);
        differenceEntry = {
          ...commonFields,
          ACCDESC: inputDifferenceValueDescription || "",
          AMOUNT: Number(differenceAmount).toFixed(2) || "",
          curamount: Number(bcDiffAmount).toFixed(2) || "",
          pdc_acc: inputCreditValueAccount || "",
          account: inputDifferenceValueAccount || "",
          ref: "ON A/C",
          type: diffType,
          rate: diffType === "D" ? "1.000000" : ((selectedCurrency || currencies[0])?.rate?.toFixed(6) || ""),
          curno: diffType === "D" ? (defaultCurrency?.curno || "") : ((selectedCurrency || currencies[0])?.curno || ""),
          accountype: "3",
        };
      }

      return differenceEntry
        ? [creditEntry, ...debitEntries, differenceEntry]
        : [creditEntry, ...debitEntries];
    };

    const finalReceiptpayload = buildReceiptPayload();
    console.log("finalReceiptpayload:", finalReceiptpayload);
    // return;
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;
    try {
      const response = await axios.post(apiUrl, finalReceiptpayload, config);
      console.log("payment data Saved:", response.data);
      setVNO(response?.data?.vno);
      setPaymentSavedPopup(true);
    } catch (error) {
      console.log("error while saving receipt", error);
    }
  };

  const onCloseSavePVPopup = () => {
    setPaymentSavedPopup(false);
    resetForm();
    onNewPayment();
  };

  const onCloseTransferPopup = () => {
    setTransferAccountPopup(false);
  };

  const requestCurrencyList = async ({ url, method, timeout }) => {
    return axios({ url, method, timeout }).then((res) => res.data);
  };

  const fetchCurrencyList = async () => {
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    try {
      const response = await requestCurrencyList({
        url,
        method: "GET",
        timeout: 10000,
      });
      setCurrencies(response || []);
      if (response && response.length > 0) {
        const defaultCurrency =
          response?.find((item) => item?.rate === 1) || response[0];
        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  const filteredSearchedCreditAccounts = searchCreditAccountTerm
    ? filteredCreditAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchCreditAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchCreditAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const filteredSearchedAccounts = searchDebitAccountTerm
    ? filteredCreditAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchDebitAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchDebitAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const filteredSearchedDifferenceAccounts = searchDifferenceAccountTerm
    ? filteredCreditAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchDifferenceAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchDifferenceAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const navigate = useNavigate();

  const onNewPayment = async () => {
    setIsEditMode(false);
    navigate("/payment");

    setinputDebitValue("");
    setselectedDebitAccount(null);
    setinputDebitValueAccount("");
    setinputDebitValueDescription("");
  };
  const onPaymentView = async () => {
    navigate("/paymentView");
  };

  const handleDrAccountSelect = (data) => {
    console.log("Dr data:", data.ACCOUNT);
    setinputDebitValue(`${data.ACCOUNT} | ${data.DESCRIPTION}`);
    setselectedDebitAccount(data);
    setinputDebitValueAccount(data.ACCOUNT);
    setinputDebitValueDescription(data.DESCRIPTION);
    setDebitModalOpen(false);
    setCreditDropdownOpen(false);
    setSearchDebitAccountTerm("");
  };

  const handleCrAccountSelect = (data) => {
    console.log("Cr data:", data.ACCOUNT);
    setselectedCr("");
    setselectedCrDesc("");
    setinputCreditValue(`${data.ACCOUNT} | ${data.DESCRIPTION}`);
    setselectedCreditAccount(data);
    setinputCreditValueAccount(data.ACCOUNT);
    setinputCreditValueDescription(data.DESCRIPTION);
    setSearchCreditAccountTerm("");
    setCreditModalOpen(false);
  };
  const handleonAccountSelect = (data) => {
    console.log("Cr data:", data.ACCOUNT);
    setDifferenceModalOpen(false);
    setinputDifferenceValue(`${data.ACCOUNT} | ${data.DESCRIPTION}`);
    setinputDifferenceValueAccount(data.ACCOUNT);
    setinputDifferenceValueDescription(data.DESCRIPTION);
    setselectedDifferenceAccount(data);
    setSearchDifferenceAccountTerm("");
  }
  const isChequeRequired = paymentMethod === "cheque";

  const isChequeInvalid =
    isChequeRequired && (!chequeNO || !chequeDate || !chequeBank);

  return (
    <div className="p-6 rounded-lg mx-auto">
      <div className="bg-[#F8F8F8] sticky top-0 z-20 "></div>
      <h2 className="text-xl text-gray-800">
        {isEditMode ? "Payment Edit" : "Payment"}
      </h2>

      <div className="flex flex-col max-w-7xl mx-auto items-start justify-left gap-6">
        <div className="flex justify-between items-end w-full">
          <div className="flex justify-center items-center select-none space-x-6">
            <label className="relative cursor-pointer">
              <input
                type="radio"
                name="payment"
                value="cash"
                checked={selected === "cash"}
                onChange={handleChange}
                className="peer absolute opacity-0 w-0 h-0"
              />
              <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white transition duration-150 ease-in-out peer-checked:border-green-500 peer-checked:bg-green-500 peer-checked:text-white">
                <DollarSign className="w-5 h-5 peer-checked:text-white" />
                <span className="text-[16px] peer-checked:text-white">
                  Cash
                </span>
              </span>
            </label>
            <label className="relative cursor-pointer">
              <input
                type="radio"
                name="payment"
                value="bank"
                checked={selected === "bank"}
                onChange={handleChange}
                className="peer absolute opacity-0 w-0 h-0"
              />
              <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white transition duration-150 ease-in-out peer-checked:border-green-500 peer-checked:bg-green-500 peer-checked:text-white">
                <Landmark className="w-5 h-5 peer-checked:text-white" />
                <span className="text-[16px] peer-checked:text-white">
                  Bank
                </span>
              </span>
            </label>
            <label className="relative cursor-pointer">
              <input
                type="radio"
                name="payment"
                value="cheque"
                checked={selected === "cheque"}
                onChange={handleChange}
                className="peer absolute opacity-0 w-0 h-0"
              />
              <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white transition duration-150 ease-in-out peer-checked:border-green-500 peer-checked:bg-green-500 peer-checked:text-white">
                <FileText className="w-5 h-5 peer-checked:text-white" />
                <span className="text-[16px] peer-checked:text-white">
                  Cheque
                </span>
              </span>
            </label>
            <label className="relative cursor-pointer">
              <input
                type="radio"
                name="payment"
                value="creditcard"
                checked={selected === "creditcard"}
                onChange={handleChange}
                className="peer absolute opacity-0 w-0 h-0"
              />
              <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white transition duration-150 ease-in-out peer-checked:border-green-500 peer-checked:bg-green-500 peer-checked:text-white">
                <CreditCard className="w-5 h-5 peer-checked:text-white" />
                <span className="text-[14.5px] peer-checked:text-white">
                  Credit Card
                </span>
              </span>
            </label>
          </div>
          <div>
            <div className="flex items-center justify-between gap-4">
              {isEditMode && (
                <button
                  onClick={onNewPayment}
                  className="relative bg-green-500 text-white font-medium text-[17px] px-4 py-[0.35em] pl-5 h-[2.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group hover:bg-green-600"
                >
                  <span className="mr-10">New</span>

                  <div className="absolute right-[0.3em] bg-white h-[2.2em] w-[2.2em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
                    <FaPlus className="text-green-500" />
                  </div>
                </button>
              )}

              <button
                onClick={onPaymentView}
                className="relative bg-yellow-500 text-white font-medium text-[17px] px-4 py-[0.35em] pl-5 h-[2.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
              >
                <span className="mr-10">View</span>
                <div className="absolute right-[0.3em] bg-white h-[2.2em] w-[2.2em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
                  <FaEye className="text-yellow-500" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#F0F4F9] border border-blue-400 px-4 rounded-lg flex justify-center items-center grid grid-cols-2 gap-4 divide-x-2 divide-white max-w-7xl mx-auto mt-4">
        <div className="grid grid-cols-3 gap-2 my-6">
          <div className="flex justify-left items-center border border-gray-300 rounded mt-7 mb-1">
            <label className="px-4 text-sm font-medium">PV No : </label>
            <p className="bg-transparent rounded px-2 py-1 text-gray-900">
              {pvnoFromAPI}
            </p>
          </div>
          <div>
            <label className="text-sm font-medium">Date</label>
            <input
              type="date"
              value={jvDate}
              onChange={(e) => setJvDate(e.target.value)}
              className="w-full text-gray-700 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 px-2 py-1 rounded mt-1"
            />
          </div>
          <div className="ml-4 w-40 flex justify-center items-end mb-2 gap-2">
            <input
              className="shadow-sm border-gray-400 focus:ring-blue-500 focus:border-blue-500 rounded-md transition-all duration-500 ease-in-out w-6 h-6"
              type="checkbox"
            />
            <label className="text-md font-medium">More Credit</label>
          </div>
          <div ref={dropdowndebitRef} className="col-span-4 relative">
            <label className="text-sm font-medium">Cr</label>
            <div className="flex items-center bg-white w-full border border-gray-300 rounded px-3 py-2">
              <input
                type="text"
                value={inputCreditValue === "-" ? "" : inputCreditValue}
                onChange={(e) => {
                  setCreditDropdownOpen(true);
                  setinputCreditValue(e.target.value);
                  setselectedCreditAccount(null);
                }}
                placeholder="Enter Credit Account"
                className="w-full px-2 py-1 rounded outline-none border-none focus:ring-0 text-gray-900"
                onKeyDown={(e) => {
                  if (e.key === "F2") {
                    e.preventDefault();
                    setCreditModalOpen(true);
                    setCreditDropdownOpen(false);
                  }
                }}
              />
              {(selectedCreditAccount ||
                (inputCreditValue && inputCreditValue !== "-")) && (
                  <button
                    type="button"
                    className="ml-2 text-gray-700 hover:text-gray-900"
                    onClick={clearCreditAccounts}
                  >
                    <ClearIcon fontSize="small" />
                  </button>
                )}
            </div>
            {creditDropdownOpen &&
              inputCreditValue?.length > 0 &&
              filteredAccounts?.length > 0 && (
                <ul
                  className="absolute bg-white border border-gray-300 w-full mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {filteredAccounts?.map((acc, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setselectedCr("");
                        setselectedCrDesc("");
                        setCreditDropdownOpen(false);
                        setinputCreditValue(
                          `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                        );
                        setinputCreditValueAccount(acc.ACCOUNT);
                        setinputCreditValueDescription(acc.DESCRIPTION);
                        setselectedCreditAccount(acc);
                      }}
                      className="px-3 py-2 text-sm flex items-center justify-left gap-6 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                    >
                      <div className="text-sm text-white px-2 py-0.5 rounded-xl bg-blue-500">
                        {acc.ACCOUNT}
                      </div>
                      <div className="font-medium text-gray-900 text-sm line-clamp-2">
                        {acc.DESCRIPTION}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
          </div>
          <div ref={dropdowncreditRef} className="col-span-4 relative">
            <label className="text-sm font-medium">Dr</label>
            <div
              ref={drInputWrapperRef}
              className={`flex items-center bg-white w-full border border-gray-300 rounded px-3 py-2 focus:ring-blue-500 ${drWrapperFocus ? "ring-2 ring-blue-500 border-blue-500" : ""
                }`}
            >
              <input
                ref={drInputRef}
                type="text"
                value={inputDebitValue === "-" ? "" : inputDebitValue}
                onChange={(e) => {
                  setDebitDropdownOpen(true);
                  setinputDebitValue(e.target.value);
                  setselectedDebitAccount(null);
                }}
                placeholder="Enter Debit Account"
                className="w-full px-2 py-1 outline-none rounded border-none focus:ring-0 text-gray-900"
                onKeyDown={(e) => {
                  if (e.key === "F2") {
                    e.preventDefault();
                    setinputDebitValue("");

                    setDebitModalOpen(true);
                    setDebitDropdownOpen(false);
                    // debitSearchInputRef.current.focus()
                  }
                }}
              />
              {(selectedDebitAccount ||
                (inputDebitValue && inputDebitValue !== "-")) && (
                  <button
                    type="button"
                    className="ml-2 text-gray-700 hover:text-gray-900"
                    onClick={clearDebitAccounts}
                  >
                    <ClearIcon fontSize="small" />
                  </button>
                )}
            </div>
            {debitDropdownOpen &&
              inputDebitValue?.length > 0 &&
              filteredCreditAccounts?.length > 0 && (
                <ul
                  className="absolute bg-white border border-gray-300 mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {filteredCreditAccounts?.map((acc, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setDebitDropdownOpen(false);
                        setinputDebitValue(
                          `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                        );
                        setinputDebitValueAccount(acc.ACCOUNT);
                        setinputDebitValueDescription(acc.DESCRIPTION);
                        setselectedDebitAccount(acc);
                        fetchOutstandingPV(acc?.ACCOUNT);
                      }}
                      className="px-3 py-2 text-sm flex items-center justify-left gap-6 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                    >
                      <div className="text-sm text-white px-2 py-0.5 rounded-xl bg-blue-500">
                        {acc.ACCOUNT}
                      </div>
                      <div className="font-medium text-gray-900 text-sm line-clamp-2">
                        {acc.DESCRIPTION}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
          </div>
          <div className="col-span-4 row-span-3">
            <label className="text-sm font-medium">Description</label>
            <textarea
              className="w-full text-gray-700 border border-gray-300 px-2 py-1 rounded mt-1"
              value={descriptionInput}
              onChange={(e) => setDescriptionInput(e.target.value)}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium  mb-1">Salesman</label>
            <select
              name="salesman"
              value={selectedSalesman?.EMP_ID || ""}
              onChange={(e) => {
                const selected = salesmanList.find(
                  (s) => s.EMP_ID === e.target.value,
                );
                setSelectedSalesman(selected);
              }}
              className="w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Salesman</option>
              {Array.isArray(salesmanList) &&
                salesmanList.map((salesMan) => (
                  <option key={salesMan.EMP_ID} value={salesMan.EMP_ID}>
                    {salesMan.NAME}
                  </option>
                ))}
            </select>
          </div>
          {paymentMethod === "cash" ? (
            ""
          ) : paymentMethod === "creditcard" ? (
            <div className="col-span-[1.5]">
              <label className="text-sm font-medium">Credit Card No.</label>
              <input
                className="w-full border border-gray-300 px-2 py-1 rounded mt-1"
                onChange={(e) => setCreditCardNo(e.target.value)}
                value={creditCardNo}
              />
            </div>
          ) : (
            isChequeRequired && (
              <div className="col-span-4">
                <div className="flex items-center gap-4">
                  <div>
                    <label className="text-sm font-medium">
                      Cheque <span className="text-red-500">*</span>
                    </label>
                    <input
                      value={chequeNO}
                      onChange={(e) => setChequeNO(e.target.value)}
                      className={`w-full px-2 py-1 rounded mt-1 border ${!chequeNO && isChequeRequired
                        ? "border-red-500"
                        : "border-gray-300"
                        }`}
                      required={isChequeRequired}
                    />
                  </div>

                  <div>
                    <label className="text-sm font-medium">
                      Cheque Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={chequeDate}
                      onChange={(e) => setChequeDate(e.target.value)}
                      className={`w-full px-2 py-1 rounded mt-1 border ${!chequeDate && isChequeRequired
                        ? "border-red-500"
                        : "border-gray-300"
                        }`}
                      required={isChequeRequired}
                    />
                  </div>

                  <div>
                    <label className="text-sm font-medium">
                      Bank <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={chequeBank}
                      onChange={(e) => setChequeBank(e.target.value)}
                      className={`w-full px-2 py-1 rounded mt-1 border ${!chequeBank && isChequeRequired
                        ? "border-red-500"
                        : "border-gray-300"
                        }`}
                      required={isChequeRequired}
                    />
                  </div>
                </div>
              </div>
            )
          )}
        </div>
        <div className="grid grid-cols-4 gap-4 my-6 pl-4">
          <div className="col-span-2">
            <label className="text-sm font-medium">Amt. Paid</label>
            <input
              ref={onACdebitRef}
              type="number"
              className="w-full border border-gray-300 text-right px-2 py-1 rounded mt-1"
              value={amtPaid}
              onChange={(e) => setAmtPaid(e.target.value)}
            />
          </div>
          <div className="flex col-span-2 items-center gap-2 mb-1">
            <div className="flex-1">
              <label className="block text-sm font-medium  mb-1">
                Foreign Currency
              </label>
              <select
                name="fc"
                value={selectedCurrency?.curno || ""}
                onChange={(e) => {
                  const selected = currencies.find(
                    (c) => c.curno === e.target.value,
                  );
                  setSelectedCurrency(selected);
                }}
                className="w-full px-3 py-2 text-sm bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {currencies.map((currency) => (
                  <option key={currency.curno} value={currency.curno}>
                    {currency.curno} - {currency.cur.trim()}
                  </option>
                ))}
              </select>
            </div>
            <div className="px-3 py-2 bg-orange-50 border border-orange-300 rounded-md mt-6">
              <span className="text-sm font-bold text-orange-600">
                {selectedCurrency?.rate?.toFixed(6)}
              </span>
            </div>
          </div>
          <div className="flex items-center col-span-2 gap-2 mt-1">
            <div className="border border-gray-300 rounded flex justify-center items-center mt-6">
              <label className="text-sm font-medium">BCur Amt.</label>
              <input
                readOnly
                value={amtPaid * selectedCurrency?.rate?.toFixed(2)}
                className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
              />
            </div>
            <label className="text-xs font-medium mt-6 ml-4">On A/C</label>
            <div className="flex items-center gap-2 mt-6">
              <label className="relative inline-block w-[3.5em] h-[2em]">
                <input
                  type="checkbox"
                  className="peer sr-only"
                  checked={isOnAc}
                  onChange={(e) => setIsOnAc(e.target.checked)}
                />
                <span
                  className="
                    absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                    after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                    after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                    after:transition-all after:duration-300 after:ease-in-out
                    after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                    peer-checked:bg-blue-500
                    peer-checked:after:translate-x-[1.5em]
                    peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                    peer-active:after:w-[3em]
                    peer-checked:peer-active:after:translate-x-[0.5em]
                  "
                ></span>
              </label>
            </div>
          </div>
          <div>
            <label className="text-sm font-medium">Job Code</label>
            <input
              value={jobCodeInput}
              onChange={(e) => setJobCodeInput(e.target.value)}
              className="w-full text-gray-700 border border-gray-300 px-2 py-1 rounded mt-1"
            />
          </div>
          <div>
            <label className="text-sm  cols-span-2 font-medium">C.Center</label>
            <input
              value={cCenterInput}
              onChange={(e) => setcCenterInput(e.target.value)}
              className="w-full text-gray-700 border border-gray-300 px-2 py-1 rounded mt-1"
            />
          </div>
          <div className="col-span-4">
            <div>
              <label className="text-sm font-medium">
                Comments <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full text-gray-700 border border-gray-300 px-2 py-1 rounded mt-1"
                value={commentsInput}
                onChange={(e) => setCommentsInput(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-4">
              {!isOnAc ? (
                <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                  <label className="text-sm font-medium">Debit :</label>
                  <input
                    readOnly
                    value={
                      transferAccountBlock
                        ? (
                          sumOfAmounts + Number(differenceAmount || 0)
                        )?.toFixed(2)
                        : sumOfAmounts?.toFixed(2)
                    }
                    className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                  />
                </div>
              ) : (
                <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                  <label className="text-sm font-medium">Debit :</label>
                  <input
                    readOnly
                    value={amtPaid * selectedCurrency?.rate?.toFixed(2)}
                    className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                  />
                </div>
              )}
              <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                <label className="text-sm font-medium">Credit : </label>
                <input
                  readOnly
                  value={(amtPaid * selectedCurrency?.rate)?.toFixed(2)}
                  className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                />
              </div>
              {!isOnAc ? (
                <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                  <label className="text-sm font-medium">Difference : </label>
                  <input
                    readOnly
                    value={
                      transferAccountBlock
                        ? (Number(sumOfAmounts || 0) + Number(differenceAmount || 0) - Number(amtPaid || 0)).toFixed(2)
                        : (differenceAmount < 0
                          ? Math.abs(Number(differenceAmount || 0))
                          : -(Number(differenceAmount || 0))
                        ).toFixed(2)
                    }
                    className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                  />
                </div>
              ) : (
                <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                  <label className="text-sm font-medium">Difference : </label>
                  <input
                    readOnly
                    value={0}
                    className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {transferAccountBlock && !isOnAc && (
        <div className="flex justify-center">
          <div className="border border-blue-400 bg-blue-100 rounded-md p-3 my-8 w-[50%]">
            <h3 className="text-md font-semibold text-gray-700 mb-2">
              Difference in Entries
            </h3>
            <div className="grid grid-cols-12 gap-2 items-center text-sm">
              <p className="col-span-2 font-medium">Account</p>
              <div className="col-span-10 relative">
                <div className="relative">
                  <input
                    type="text"
                    value={
                      inputDifferenceValue === "-" ? "" : inputDifferenceValue
                    }
                    onChange={(e) => {
                      setDifferenceDropdownOpen(true);
                      setinputDifferenceValue(e.target.value);
                      setselectedDifferenceAccount(null);
                    }}
                    placeholder="Enter Difference Account"
                    className="w-full px-2 pr-8 py-1 rounded outline-none border border-gray-300 focus:ring-0 text-gray-900"
                    onKeyDown={(e) => {
                      if (e.key === "F2") {
                        fetchAccountList("EXPENSES");
                        setDifferenceModalOpen(true);
                        setDifferenceDropdownOpen(false);
                      }
                    }}
                  />
                  {(selectedDifferenceAccount ||
                    (inputDifferenceValue && inputDifferenceValue !== "-")) && (
                      <button
                        type="button"
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        onClick={clearDifferenceAccounts}
                      >
                        <ClearIcon fontSize="small" />
                      </button>
                    )}
                </div>
                {differenceDropdownOpen &&
                  filteredCreditAccounts?.length > 0 && (
                    <ul
                      className="absolute left-0 right-0 bg-white border border-gray-300 mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {filteredCreditAccounts?.map((acc, i) => (
                        <li
                          key={i}
                          onClick={() => {
                            setDifferenceDropdownOpen(false);
                            setinputDifferenceValue(
                              `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                            );
                            setinputDifferenceValueAccount(acc.ACCOUNT);
                            setinputDifferenceValueDescription(acc.DESCRIPTION);
                            setselectedDifferenceAccount(acc);
                          }}
                          className="px-3 py-2 text-sm flex items-center gap-4 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                        >
                          <div className="text-sm text-white px-2 py-0.5 rounded-xl bg-blue-500">
                            {acc.ACCOUNT}
                          </div>
                          <div className="font-medium text-gray-900 text-sm line-clamp-2">
                            {acc.DESCRIPTION}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
              <div className="col-span-2 font-medium">REF</div>
              <div className="col-span-4 bg-white px-2 py-1 rounded">
                ON A/C
              </div>
              <div className="col-span-2 font-medium text-right">Amount</div>
              <div className="col-span-4 bg-white px-2 py-1 rounded focus-within:ring-2 focus-within:ring-blue-500">
                <input
                  className="w-full focus:outline-none border-none"
                  value={differenceAmount}
                  onChange={(e) => setDifferenceAmount(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-wrap items-center justify-between gap-4 text-sm my-4 max-w-7xl mx-auto w-full bg-white p-2 rounded-lg">
        {/* Left Section: Filter toggle and Search input */}
        {isTableVisible && !isOnAc && (
          <div className="flex items-center gap-6 flex-1 min-w-[300px]">
            {/* Date Filter Toggle Switch */}
            <div className="flex items-center gap-2 shrink-0">
              <label className="relative inline-block w-[3.5em] h-[2em]">
                <input
                  type="checkbox"
                  className="peer sr-only"
                  checked={isFilterByDate}
                  onChange={(e) => setIsFilterByDate(e.target.checked)}
                />
                <span
                  className="
            absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
            after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
            after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
            after:transition-all after:duration-300 after:ease-in-out
            after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
            peer-checked:bg-blue-500
            peer-checked:after:translate-x-[1.5em]
            peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
            peer-active:after:w-[3em]
            peer-checked:peer-active:after:translate-x-[0.5em]
          "
                ></span>
              </label>
              <span className="text-sm font-medium whitespace-nowrap">Filter By Date</span>
            </div>

            {/* Search Input */}
            <div className="flex items-center gap-2 border border-gray-300 rounded px-3 py-1.5 flex-1 max-w-md">
              <Search className="h-4 w-4 text-gray-400 shrink-0" />
              <input
                type="text"
                placeholder="Search outstanding bills..."
                value={outstandingSearchTerm}
                onChange={(e) => setOutstandingSearchTerm(e.target.value)}
                className="w-full text-sm focus:outline-none bg-transparent"
              />
            </div>
          </div>
        )}

        {/* Middle Section: Inline Date Pickers and Date Actions */}
        {isTableVisible && isFilterByDate && (
          <div className="flex items-center gap-3 bg-gray-50 p-1.5 rounded-md border border-gray-100">
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-gray-600 whitespace-nowrap">From:</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="border border-gray-300 px-2 py-1 rounded text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs font-medium text-gray-600 whitespace-nowrap">To:</label>
              <input
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
                className="border border-gray-300 px-2 py-1 rounded text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-1.5 ml-1">
              <button
                type="button"
                onClick={fetchOutstandingPV}
                className="px-3 py-1 text-xs rounded bg-blue-600 text-white shadow hover:bg-blue-700 transition"
              >
                Apply
              </button>
              <button
                type="button"
                onClick={handleClear}
                className="px-3 py-1 text-xs rounded bg-gray-500 text-white hover:bg-gray-700 transition"
              >
                Clear
              </button>
            </div>
          </div>
        )}

        {/* Right Section: Core Utility Actions (Save & Extend) */}
        <div className="flex items-center gap-3 ml-auto shrink-0">
          {isTableVisible && (
            <button
              onClick={onSavePayment}
              disabled={
                (!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1) || isChequeInvalid
              }
              className={`relative font-medium text-sm px-4 py-1.5 pl-5 h-[2.5em] rounded-[0.7em] flex items-center overflow-hidden cursor-pointer group transition
          ${(!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1) || isChequeInvalid
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
            >
              <span className="mr-8 whitespace-nowrap">
                {isEditMode ? "Save Edit" : "Save"}
              </span>
              <div
                className="absolute right-[0.2em] bg-white h-[2.1em] w-[2.1em] rounded-[0.5em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.4em)] active:scale-95"
              >
                <FaSave
                  className={`${(!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1)
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-blue-500"
                    }`}
                />
              </div>
            </button>
          )}

          {isTableVisible && !isOnAc && (
            <button
              className="p-1.5 bg-white text-black rounded border border-gray-300 hover:bg-gray-50 transition flex items-center justify-center"
              onClick={() => setIsExtendTable(!isExtendTable)}
            >
              {isExtendTable ? (
                <TbLayoutSidebarRightExpand className="text-xl" />
              ) : (
                <TbLayoutSidebarLeftExpand className="text-xl" />
              )}
            </button>
          )}
        </div>
      </div>

      {isTableVisible && !isOnAc && (
        <div className="max-h-[800px] max-w-7xl overflow-y-auto border rounded mb-4 mx-auto bg-white relative isolate">
          <table className="w-full text-sm">
            <thead>
              <tr>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Amount
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Select
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Bal Amount
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Inv No
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Inv Date
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                  Description
                </th>
                {isExtendTable && (
                  <>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      Job Code
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      Cost Center
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      Cur
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      Rate
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      FC Amount
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1 font-semibold">
                      Dept No
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const filtered = (outstandingPV || []).reduce((acc, item, idx) => {
                  if (!outstandingSearchTerm) { acc.push({ item, idx }); return acc; }
                  const term = outstandingSearchTerm.toLowerCase();
                  if (
                    String(item.INV || "").toLowerCase().includes(term) ||
                    String(item.DESCR || "").toLowerCase().includes(term) ||
                    String(item.BalAmt || "").toLowerCase().includes(term) ||
                    String(item.JOBCODE || "").toLowerCase().includes(term) ||
                    String(item.CUR || "").toLowerCase().includes(term)
                  ) {
                    acc.push({ item, idx });
                  }
                  return acc;
                }, []);
                return filtered.length > 0 ? filtered.map(({ item: outPV, idx: index }) => (
                  <tr key={index}>
                    <td className="border w-24 bg-white ">
                      {/* <div className="flex justify-right items-center"> */}

                      <input
                        type="number"
                        value={amounts[index] ?? ""}
                        onChange={(e) =>
                          handleAmountChange(index, e.target.value)
                        }
                        className="w-full  border-none text-right rounded"
                      />
                      {/* </div> */}
                    </td>
                    <td className="border w-24  bg-white px-2 py-1 text-center">
                      <label className="relative inline-block w-[3.5em] h-[2em]">
                        <input
                          type="checkbox"
                          className="peer sr-only"
                          checked={!!selectedToggle[index]}
                          onChange={(e) =>
                            handleSelectToggle(
                              index,
                              e.target.checked,
                              outPV?.BalAmt,
                            )
                          }
                        />
                        <span
                          className="absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                            after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                            after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                            after:transition-all after:duration-300 after:ease-in-out
                            after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                            peer-checked:bg-blue-500
                            peer-checked:after:translate-x-[1.5em]
                            peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                            peer-active:after:w-[3em]
                            peer-checked:peer-active:after:translate-x-[0.5em]"
                        ></span>
                      </label>
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {outPV?.BalAmt}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {outPV?.INV}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {dayjs(outPV?.INVDATE).format("DD/MM/YYYY")}
                    </td>
                    <td className="border bg-white px-2 py-1 text-left">
                      {outPV?.DESCR}
                    </td>
                    {isExtendTable && (
                      <>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outPV?.JOBCODE}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outPV?.COSTC}
                        </td>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outPV?.CUR}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outPV?.RATE}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outPV?.FCBalAmt}
                        </td>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outPV?.deptno}
                        </td>
                      </>
                    )}
                  </tr>
                ))
                  : (
                    <tr>
                      <td
                        colSpan={isExtendTable ? 11 : 6}
                        className="text-center py-4 text-gray-500"
                      >
                        No outstanding data available
                      </td>
                    </tr>
                  );
              })()}
            </tbody>
          </table>
        </div>
      )}

      {debitModalOpen && (
        <Modal
          isOpen={debitModalOpen}
          onClose={() => setDebitModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleDrAccountSelect}
          />
        </Modal>
      )}

      {/* {debitModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded shadow-lg h-[68vh] flex flex-col max-w-4xl w-full mx-6 px-6">
            <div className="flex justify-between items-center py-4 border-b bg-white rounded-t sticky top-0 z-20">
              <h2 className="text-lg font-semibold">Select Debit Account</h2>
              <button
                className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                onClick={() => {
                  setDebitModalOpen(false);
                  setValueToDebit("SUPPLIERS");
                  setSearchDebitAccountTerm("");
                }}
              >
                <ClearIcon fontSize="small" />
              </button>
            </div>
            <div className="flex justify-left gap-8 overflow-y-auto mt-8">
              <div className="sticky top-0 z-20">
                <nav className="space-y-1 mt-4 mr-4">
                  {types.map(({ name, icon: Icon, disable = false }) => {
                    const isSelected = valueToDebit === name.toUpperCase();
                    return (
                      <button
                        key={name}
                        onClick={() => {
                          if (!disable) {
                            setValueToDebit(name.toUpperCase());
                          }
                        }}
                        className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg transition-colors
                          ${disable ? "opacity-60 cursor-not-allowed" : ""}
                          ${
                            isSelected
                              ? "bg-blue-100 text-blue-700 border border-blue-200"
                              : "text-gray-700 hover:bg-gray-100"
                          }`}
                        disabled={disable}
                      >
                        <div className="flex items-center">
                          <Icon className="w-4 h-4 mr-3" />
                          {name}
                        </div>
                      </button>
                    );
                  })}
                </nav>
              </div>
              <div className="mt-2">
                <div className="relative flex-1 mr-2 mb-4">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    ref={debitSearchInputRef}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white shadow-sm"
                    type="text"
                    placeholder="Search Account"
                    value={searchDebitAccountTerm}
                    onChange={(e) => setSearchDebitAccountTerm(e.target.value)}
                  />
                  {searchDebitAccountTerm && (
                    <button
                      type="button"
                      onClick={() => setSearchDebitAccountTerm("")}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <ClearIcon fontSize="small" />
                    </button>
                  )}
                </div>
                {loading ? (
                  <p className="text-sm text-gray-600">Loading...</p>
                ) : (
                  <p className="text-sm text-gray-600">
                    Showing{" "}
                    {(filteredSearchedAccounts || filteredAccounts).length}{" "}
                    accounts {value !== "All" && `in ${valueToDebit}`}
                  </p>
                )}
                <div className="bg-white mt-2 rounded-lg shadow-sm border border-gray-200 max-h-[70%] pb-2 overflow-y-auto w-[100%]">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
                        <tr>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Account
                          </th>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Description
                          </th>
                          <th className="px-5 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                            Balance
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div className="overflow-y-auto">
                    <table className="w-full">
                      <tbody className="divide-y divide-gray-200">
                        {loading ? (
                          <tr>
                            <td colSpan="4" className="py-12 text-center">
                              <div className="flex flex-col items-center justify-center">
                                <svg
                                  className="animate-spin h-8 w-8 text-blue-500 mb-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <p className="text-sm text-gray-500">
                                  Loading accounts...
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (filteredSearchedAccounts || filteredAccounts)
                            ?.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="py-12 text-center">
                              <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                              <p className="text-lg font-medium text-gray-900 mb-1">
                                No accounts found
                              </p>
                              <p className="text-sm text-gray-500">
                                Try a different filter or search
                              </p>
                            </td>
                          </tr>
                        ) : (
                          (filteredSearchedAccounts || filteredAccounts)?.map(
                            (acc, i) => (
                              <tr
                                key={i}
                                onClick={() => {
                                  setinputDebitValue(
                                    `${acc.ACCOUNT} - ${acc.DESCRIPTION}`
                                  );
                                  setselectedDebitAccount(acc);
                                  setinputDebitValueAccount(acc.ACCOUNT);
                                  setinputDebitValueDescription(
                                    acc.DESCRIPTION
                                  );
                                  setDebitModalOpen(false);
                                  setCreditDropdownOpen(false);
                                  setSearchDebitAccountTerm("");
                                }}
                                className="hover:bg-gray-50 cursor-pointer"
                              >
                                <td className="px-5 py-3 text-sm font-medium text-gray-900">
                                  {acc.ACCOUNT}
                                </td>
                                <td className="px-5 py-3 text-sm text-gray-700">
                                  {acc.DESCRIPTION}
                                </td>
                                <td
                                  className={`px-5 py-3 text-sm text-right font-medium ${
                                    acc.BALANCE > 0
                                      ? "text-green-600"
                                      : acc.BALANCE < 0
                                      ? "text-red-600"
                                      : "text-gray-700"
                                  }`}
                                >
                                  {formatBalance(acc.BALANCE)}
                                </td>
                              </tr>
                            )
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {creditModalOpen && (
        <Modal
          isOpen={creditModalOpen}
          onClose={() => setCreditModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="Bank"
            handleCustomerSelect={handleCrAccountSelect}
          />
        </Modal>
      )}

      {/* {creditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded shadow-lg h-[68vh] flex flex-col max-w-4xl w-full mx-6 px-6">
            <div className="flex justify-between items-center py-4 border-b bg-white rounded-t sticky top-0 z-20">
              <h2 className="text-lg font-semibold">Select Credit Account</h2>
              <button
                className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                onClick={() => {
                  setCreditModalOpen(false);
                  setSearchCreditAccountTerm("");
                }}
              >
                <ClearIcon fontSize="small" />
              </button>
            </div>
            <div className="flex justify-left gap-8 overflow-y-auto mt-4">
              <div className="sticky top-0 z-20">
                <nav className="space-y-1 mt-2 mr-4">
                  {types.map(({ name, icon: Icon }) => {
                    const isSelected = value === name.toUpperCase();
                    const allowedType =
                      typeMapping[paymentMethod?.toLowerCase()] || null;
                    const disable = allowedType ? name !== allowedType : true;
                    return (
                      <button
                        key={name}
                        onClick={() => {
                          if (!disable) {
                            setValue(name.toUpperCase());
                          }
                        }}
                        className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg transition-colors
                          ${disable ? "opacity-60 cursor-not-allowed" : ""}
                          ${
                            isSelected
                              ? "bg-blue-100 text-blue-700 border border-blue-200"
                              : "text-gray-700 hover:bg-gray-100"
                          }`}
                        disabled={disable}
                      >
                        <div className="flex items-center">
                          <Icon className="w-4 h-4 mr-3" />
                          {name}
                        </div>
                      </button>
                    );
                  })}
                </nav>
              </div>
              <div className="mt-2">
                <div className="relative flex-1 mr-2 mb-4">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white shadow-sm"
                    type="text"
                    // ref={searchInputRef}
                    ref={creditSearchInputRef}
                    placeholder="Search Account"
                    value={searchCreditAccountTerm}
                    onChange={(e) => setSearchCreditAccountTerm(e.target.value)}
                  />
                  {searchCreditAccountTerm && (
                    <button
                      type="button"
                      onClick={() => setSearchCreditAccountTerm("")}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <ClearIcon fontSize="small" />
                    </button>
                  )}
                </div>
                {loading ? (
                  <p className="text-sm text-gray-600">Loading...</p>
                ) : (
                  <p className="text-sm text-gray-600">
                    Showing{" "}
                    {
                      (filteredSearchedCreditAccounts || filteredAccounts)
                        .length
                    }{" "}
                    accounts {value !== "All" && `in ${value}`}
                  </p>
                )}
                <div className="bg-white mt-2  rounded-lg shadow-sm border border-gray-200 max-h-[70%] pb-2 overflow-y-auto w-[100%]">
                  <div className="overflow-x-auto">
                    <table className="w-full ">
                      <thead className="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
                        <tr>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Account
                          </th>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Description
                          </th>{" "}
                          <th className="px-5 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                            Balance
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>

                  <div className="  overflow-y-auto  ">
                    <table className="w-full">
                      <tbody className="divide-y divide-gray-200">
                        {loading ? (
                          <tr>
                            <td colSpan="4" className="py-12 text-center">
                              <div className="flex flex-col items-center justify-center">
                                <svg
                                  className="animate-spin h-8 w-8 text-blue-500 mb-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <p className="text-sm text-gray-500">
                                  Loading accounts...
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (filteredSearchedCreditAccounts || filteredAccounts)
                            ?.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="py-12 text-center">
                              <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                              <p className="text-lg font-medium text-gray-900 mb-1">
                                No accounts found
                              </p>
                              <p className="text-sm text-gray-500">
                                Try a different filter or search
                              </p>
                            </td>
                          </tr>
                        ) : (
                          (
                            filteredSearchedCreditAccounts || filteredAccounts
                          )?.map((acc, i) => (
                            <tr
                              key={i}
                              onClick={() => {
                                setselectedCr("");
                                setselectedCrDesc("");
                                setinputCreditValue(
                                  `${acc.ACCOUNT} - ${acc.DESCRIPTION}`
                                );
                                setselectedCreditAccount(acc);
                                setinputCreditValueAccount(acc.ACCOUNT);
                                setinputCreditValueDescription(acc.DESCRIPTION);
                                setSearchCreditAccountTerm("");
                                setCreditModalOpen(false);
                              }}
                              className="hover:bg-gray-50 cursor-pointer"
                            >
                              <td className="px-5 py-3 text-sm font-medium text-gray-900">
                                {acc.ACCOUNT}
                              </td>
                              <td className="px-5 py-3 text-sm text-gray-700">
                                {acc.DESCRIPTION}
                              </td>
                              <td
                                className={`px-5 py-3 text-sm text-right font-medium ${
                                  acc.BALANCE > 0
                                    ? "text-green-600"
                                    : acc.BALANCE < 0
                                    ? "text-red-600"
                                    : "text-gray-700"
                                }`}
                              >
                                {formatBalance(acc.BALANCE)}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {transferAccountPopup && !isOnAc && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm overflow-hidden animate-fadeIn">
            <div className="px-4 py-3 bg-yellow-50 border-b border-yellow-200">
              <h2 className="text-yellow-700 font-semibold text-base flex items-center gap-2">
                ⚠️ Warning
              </h2>
            </div>

            <div className="px-5 py-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                Voucher not tallied. Do you want to continue with adjustment?
              </p>
            </div>

            <div className="px-5 py-3 flex justify-end gap-3 border-t bg-gray-50">
              <button
                onClick={onCloseTransferPopup}
                className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm rounded-md transition"
              >
                No
              </button>
              <button
                onClick={onConfirmPaymentTransferPopup}
                className="px-4 py-1.5 bg-red-500 hover:bg-red-600 text-white text-sm rounded-md shadow-sm transition"
              >
                Yes, Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {differenceModalOpen && (
        // <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
        //   <div className="bg-white rounded shadow-lg h-[68vh] flex flex-col max-w-4xl w-full mx-6 px-6">
        //     {/* Fixed Modal Header */}
        //     <div className="flex justify-between items-center py-4 border-b bg-white rounded-t sticky top-0 z-20">
        //       <h2 className="text-lg font-semibold">
        //         Select Difference Account
        //       </h2>

        //       <button
        //         className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
        //         onClick={() => {
        //           setDifferenceModalOpen(false);
        //           setValueToDifference("EXPENSES");
        //           setSearchDifferenceAccountTerm("");
        //         }}
        //       >
        //         <ClearIcon fontSize="small" />
        //       </button>
        //     </div>

        //     {/* Scrollable Content Container */}
        //     <div className="flex justify-left gap-8 overflow-y-auto mt-4">
        //       <div className=" sticky top-0 z-20">
        //         <nav className="space-y-1 mt-2 mr-4">
        //           {types.map(({ name, icon: Icon }) => {
        //             const isSelected = valueToDifference === name.toUpperCase();
        //             return (
        //               <button
        //                 key={name}
        //                 onClick={() => {
        //                   // if (!disable) {
        //                   // setValue(name);
        //                   console.log(
        //                     "set the difference value,",
        //                     name.toUpperCase(),
        //                   );
        //                   setValueToDifference(name.toUpperCase());
        //                   // fetchAccountList(name.toUpperCase())

        //                   // setSearchTerm("");
        //                   // if (window.innerWidth < 768) {
        //                   //   setSidebarVisible(false);
        //                   // }
        //                   // }
        //                 }}
        //                 className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg transition-colors

        //               ${isSelected
        //                     ? "bg-blue-100 text-blue-700 border border-blue-200"
        //                     : "text-gray-700 hover:bg-gray-100"
        //                   }`}
        //               >
        //                 <div className="flex items-center">
        //                   <Icon className="w-4 h-4 mr-3" />
        //                   {name}
        //                 </div>
        //               </button>
        //             );
        //           })}
        //         </nav>
        //       </div>

        //       {/* Table */}

        //       <div className="mt-2">
        //         <div className="relative flex-1 mr-2 mb-4">
        //           <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        //           <input
        //             className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white shadow-sm"
        //             // className="w-[50%] pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white shadow-sm"
        //             type="text"
        //             ref={differenceSearchInputRef}
        //             placeholder="Search Difference Account"
        //             value={searchDifferenceAccountTerm}
        //             onChange={(e) =>
        //               setSearchDifferenceAccountTerm(e.target.value)
        //             }
        //           />
        //           {searchDifferenceAccountTerm && (
        //             <button
        //               type="button"
        //               onClick={() => setSearchDifferenceAccountTerm("")}
        //               className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
        //             >
        //               <ClearIcon fontSize="small" />
        //             </button>
        //           )}
        //         </div>
        //         {loading ? (
        //           <p className="text-sm text-gray-600">Loading...</p>
        //         ) : (
        //           <p className="text-sm text-gray-600">
        //             Showing {filteredSearchedDifferenceAccounts.length} accounts{" "}
        //             {value !== "All" && `in ${valueToDifference}`}
        //           </p>
        //         )}
        //         <div className="bg-white mt-2  rounded-lg shadow-sm border border-gray-200 max-h-[70%] pb-2 overflow-y-auto w-[100%]">
        //           <div className="overflow-x-auto">
        //             <table className="w-full ">
        //               <thead className="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
        //                 <tr>
        //                   <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        //                     Account
        //                   </th>
        //                   <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        //                     Description
        //                   </th>{" "}
        //                   <th className="px-5 py-3 text-right text-xs font-medium text-gray-500 uppercase">
        //                     Balance
        //                   </th>
        //                 </tr>
        //               </thead>
        //             </table>
        //           </div>

        //           <div className="  overflow-y-auto mb-8 ">
        //             <table className="w-full">
        //               <tbody className="divide-y divide-gray-200">
        //                 {loading ? (
        //                   <tr>
        //                     <td colSpan="4" className="py-12 text-center">
        //                       <div className="flex flex-col items-center justify-center">
        //                         <svg
        //                           className="animate-spin h-8 w-8 text-blue-500 mb-3"
        //                           xmlns="http://www.w3.org/2000/svg"
        //                           fill="none"
        //                           viewBox="0 0 24 24"
        //                         >
        //                           <circle
        //                             className="opacity-25"
        //                             cx="12"
        //                             cy="12"
        //                             r="10"
        //                             stroke="currentColor"
        //                             strokeWidth="4"
        //                           ></circle>
        //                           <path
        //                             className="opacity-75"
        //                             fill="currentColor"
        //                             d="M4 12a8 8 0 018-8v8z"
        //                           ></path>
        //                         </svg>
        //                         <p className="text-sm text-gray-500">
        //                           Loading accounts...
        //                         </p>
        //                       </div>
        //                     </td>
        //                   </tr>
        //                 ) : filteredSearchedDifferenceAccounts?.length === 0 ? (
        //                   <tr>
        //                     <td colSpan="4" className="py-12 text-center">
        //                       <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
        //                       <p className="text-lg font-medium text-gray-900 mb-1">
        //                         No accounts found
        //                       </p>
        //                       <p className="text-sm text-gray-500">
        //                         Try a different filter or search
        //                       </p>
        //                     </td>
        //                   </tr>
        //                 ) : (
        //                   filteredSearchedDifferenceAccounts?.map((acc, i) => (
        //                     <tr
        //                       key={i}
        //                       onClick={() => {
        //                         // setSelectedDr("");
        //                         // setSelectedDrDesc("");
        //                         setinputDifferenceValue(
        //                           `${acc.ACCOUNT} - ${acc.DESCRIPTION}`,
        //                         );
        //                         setinputDifferenceValueAccount(acc.ACCOUNT);
        //                         setinputDifferenceValueDescription(
        //                           acc.DESCRIPTION,
        //                         );
        //                         setSearchDifferenceAccountTerm("");
        //                         setDifferenceModalOpen(false);
        //                       }}
        //                       className="hover:bg-gray-50 cursor-pointer"
        //                     >
        //                       <td className="px-5 py-3 text-sm font-medium text-gray-900">
        //                         {acc.ACCOUNT}
        //                       </td>
        //                       <td className="px-5 py-3 text-sm text-gray-700">
        //                         {acc.DESCRIPTION}
        //                       </td>
        //                       <td
        //                         className={`px-5 py-3 text-sm text-right font-medium ${acc.BALANCE > 0
        //                           ? "text-green-600"
        //                           : acc.BALANCE < 0
        //                             ? "text-red-600"
        //                             : "text-gray-700"
        //                           }`}
        //                       >
        //                         {formatBalance(acc.BALANCE)}
        //                       </td>
        //                     </tr>
        //                   ))
        //                 )}
        //               </tbody>
        //             </table>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        <Modal
          isOpen={differenceModalOpen}
          onClose={() => setDifferenceModalOpen(false)}
          title={"Customer List"}
          size="xxl"
          header={true}

        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleonAccountSelect}
          />
        </Modal>
      )}

      {paymentSavedPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm overflow-hidden animate-fadeIn">
            <div className="px-4 py-3 bg-green-200 border-b border-green-200">
              <h2 className="text-green-700 font-semibold text-base flex items-center gap-2">
                {isEditMode ? "Edit Payment" : "Save Payment"}
              </h2>
            </div>

            <div className="px-5 py-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                Payment Voucher #{vNO} {isEditMode ? "Editted" : "Saved"}{" "}
                Succesfully!
              </p>
            </div>

            <div className="px-5 py-3 flex justify-end gap-3 border-t bg-gray-50">
              <button
                onClick={onCloseSavePVPopup}
                className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm rounded-md transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Payment;
